/** JWT del shell D28D — separado del token FOOD en localStorage (mismo origen / iframe). */
const SHELL_TOKEN_KEY = 'd28d_token';
const LEGACY_TOKEN_KEY = 'token';

function decodeJwtPayload(token) {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function jwtSubject(payload) {
  if (!payload) return null;
  return payload.sub ?? payload.id ?? null;
}

/** Shell JWT: sub numérico (id usuario D28D). */
export function isShellJwt(token) {
  const sub = jwtSubject(decodeJwtPayload(token));
  if (sub == null) return false;
  return typeof sub === 'number' || (typeof sub === 'string' && /^\d+$/.test(sub));
}

/** Food JWT: sub UUID o claim role de Food. */
export function isFoodJwt(token) {
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  const sub = jwtSubject(payload);
  if (typeof sub === 'string' && /^[0-9a-f-]{36}$/i.test(sub)) return true;
  return ['USER', 'TRAINER', 'ADMIN', 'SUPER_ADMIN'].includes(payload.role);
}

/** Quita tokens FOOD de la clave legacy `token` (compartida con iframe). */
export function sanitizeSharedStorageForShell() {
  try {
    const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
    if (legacy && isFoodJwt(legacy) && !isShellJwt(legacy)) {
      localStorage.removeItem(LEGACY_TOKEN_KEY);
    }
  } catch { /* noop */ }
}

export function getShellToken() {
  try {
    sanitizeSharedStorageForShell();
    const dedicated = localStorage.getItem(SHELL_TOKEN_KEY);
    if (dedicated && isShellJwt(dedicated)) return dedicated;

    const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
    if (legacy && isShellJwt(legacy)) {
      localStorage.setItem(SHELL_TOKEN_KEY, legacy);
      localStorage.removeItem(LEGACY_TOKEN_KEY);
      return legacy;
    }

    return dedicated || null;
  } catch {
    return null;
  }
}

export function setShellToken(token) {
  try {
    if (token) {
      localStorage.setItem(SHELL_TOKEN_KEY, token);
      const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
      if (!legacy || isShellJwt(legacy)) {
        localStorage.removeItem(LEGACY_TOKEN_KEY);
      }
    } else {
      localStorage.removeItem(SHELL_TOKEN_KEY);
      const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
      if (legacy && isShellJwt(legacy)) {
        localStorage.removeItem(LEGACY_TOKEN_KEY);
      }
    }
  } catch { /* noop */ }
}

export function clearShellToken() {
  setShellToken(null);
}
